import axios from 'axios'
import { CANCELAR_PEDIDO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function cancelarReservasPedido (motivo, idEmpresa, idPedido) {
  const url = `${URL}/reserva/cancelar-pedido`;
  return dispatch => axios.post(url,{ motivo, idEmpresa, idPedido} , SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: CANCELAR_PEDIDO,
        payload: response
      })
  );
}
